<template>
  <div class="modal_wrapper" >
    <div class="modal" v-bind:style="{height:height}" >
      <div class="close_button">
         <i class="close large icon" style="margin:0px" v-on:click="closeMe"></i>
      </div>
      <slot></slot> 
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TheSimpleModal',
    props: ['height'],

    methods: {
      closeMe: function() {
       
        this.$emit('closeMe');
      },
      closeGalleryEsc: function(e) {
        if (event.key === "Escape") {
          e.preventDefault();
          this.closeMe();
          document.removeEventListener("keydown",this.closeGalleryEsc);
        }
      }

    },
    mounted() {
      document.addEventListener("keydown", this.closeGalleryEsc);
    }
  }
</script>

<style scoped>
  .modalold {
    position: relative;
    top: -100px;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    max-height: 110vh;
    margin: auto;
    padding: 35px;
    background-color: #ffffff;
    border: 1px solid darkgray;
    border-radius: 5px;
    box-shadow: 0 0 0 100vmax rgba(0, 0, 0, .6);
   

  }

  .modal {
    background-color: #ffffff;
    border: 1px solid darkgray;
    border-radius: 5px;
    box-shadow: 0 0 0 100vmax rgba(0, 0, 0, .6);
    padding: 30px;

  }

  .modal_wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index:10;




  }

  .close_button {
    position: absolute;
    right: 0px;
    top: 0px;
    cursor: pointer;
    margin: 6px 18px;
    border-radius: 4px;
  }

  .close_button:hover {
    color: rgb(80, 130, 191);

  }
</style>



// WEBPACK FOOTER //
// src/components/TheSimpleModal.vue